import { PORTAL_ID } from './getPortalId';
export const getFullSearchUrl = (searchQuery = '') => {
  return `/search/${PORTAL_ID}/search?query=${encodeURIComponent(searchQuery)}`;
};